import { ClassifierAutoComplete } from '@atlas-frontend/sdk';

interface ClassifierFilterInputProps {
  onChange?: (value?: string) => void;
  value?: string;
  selectedClassifier?: string;
}

export const ClassifierFilterInput = (props: ClassifierFilterInputProps) => {
  const { value, onChange, selectedClassifier } = props;

  return (
    <ClassifierAutoComplete
      id="classifier-filter"
      onChange={onChange}
      selectedClassifier={selectedClassifier}
      value={value}
    />
  );
};
